import { useMemo, type ReactNode } from 'react';
import { ProjectNoEditsCornerBadge } from '@/components/ProjectsTable/ProjectNoEditsCornerBadge';
import { TableCellCommentShell } from './TableCellCommentShell';
import './ProjectTableCellCommentShell.css';

interface ProjectTableCellCommentShellProps {
  projectId: string;
  projectName: string;
  columnId: string;
  historyColumnId?: string;
  historyColumnIds?: string[];
  historyTitle?: string;
  commentCount: number;
  showNoEditsBadge?: boolean;
  children: ReactNode;
}

export function ProjectTableCellCommentShell({
  projectId,
  projectName,
  columnId,
  historyColumnId,
  historyColumnIds,
  historyTitle,
  commentCount,
  showNoEditsBadge = false,
  children,
}: ProjectTableCellCommentShellProps) {
  const projectTarget = useMemo(
    () =>
      ({ kind: 'project' as const, projectId, projectName, columnId }),
    [projectId, projectName, columnId]
  );

  const cornerLeading =
    showNoEditsBadge && columnId === 'name' ? <ProjectNoEditsCornerBadge /> : null;
  const changeHistory =
    historyColumnId || historyColumnIds?.length
      ? {
          projectId,
          projectName,
          columnId: historyColumnIds?.length ? undefined : historyColumnId,
          columnIds: historyColumnIds?.length ? historyColumnIds : undefined,
          title: historyTitle,
        }
      : undefined;

  return (
    <TableCellCommentShell
      target={projectTarget}
      commentCount={commentCount}
      cornerLeading={cornerLeading}
      changeHistory={changeHistory}
    >
      {children}
    </TableCellCommentShell>
  );
}
